import i18n from '@/libs/i18n'

const { t } = i18n.global

enum Errors {
    InternalServerError = 1,
    InvalidData,
    NotFound,
    Unauthorized,
    UserExist,
    UserDoesNotExist,
    ErrFailedToInsert
}

const parseError = (errorObject: unknown, fallback = '') => {
    if (errorObject === null || errorObject === undefined
        || !(errorObject instanceof Object)
        || !('error' in errorObject)
        || !errorObject.error
        || !(errorObject.error instanceof Object)
        || !('code' in errorObject.error)
        || errorObject.error.code === Errors.InternalServerError) {
        if (fallback && fallback !== '') return fallback
        return t('errors.generic_error')
    }

    switch (errorObject.error.code) {
        case Errors.InvalidData:
            return t('errors.invalid_data')
        case Errors.NotFound:
            return t('errors.not_found')
        case Errors.Unauthorized:
            return t('errors.unauthorized')
        case Errors.UserExist:
            return t('errors.user_exist')
        case Errors.UserDoesNotExist:
            return t('errors.user_does_not_exist')
        default:
            return t('errors.generic_error')
    }
}

export { parseError }
